import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from '../store/index'
import alert from './services/alert'
import modal from './services/modal'
import loading from './services/loading'
import './assets/styles/index.css'
import './assets/styles/icons.css'
import Maska from 'maska';
import VueApexCharts from "vue3-apexcharts";




const app = createApp(App);


app
.use(store)
.use(router)
//.use(VueApexCharts)
.use(Maska)
.provide('alert', alert)
.provide('loading', loading)
.provide('modal', modal)
.mount('#app')
